import { computed as t } from "vue";
import { useBindCx as r } from "@scalar/use-hooks/useBindCx";
const n = "regular";
function u(e = {}) {
  const { cx: a } = r(), i = t(
    () => e.label ? { "aria-label": e.label } : { "aria-hidden": !0, role: "presentation" }
  );
  return {
    bind: t(() => ({
      width: "1em",
      height: "1em",
      ...i.value,
      ...a()
    })),
    weight: t(() => e.weight ?? n)
  };
}
export {
  u as useScalarIcon
};
